import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { Button } from 'components';
import SbpLogo from '../assets/sbp-logo-white-text.svg';
import { SPF_TEXT_CONFIG } from '../sfpPaymentHelper';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const SpfButton = ({ onClick, disabled }) => (
  <Button
    type="button"
    wide
    color="light"
    disabled={disabled}
    className={cx('btn')}
    onClick={onClick}
  >
    <span className={cx('btn__content')}>
      <span className={cx('btn__text')}>
        {SPF_TEXT_CONFIG.spfButtonText}
      </span>
      <SbpLogo />
    </span>
  </Button>
);

SpfButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default SpfButton;
